import type { ReactNode } from 'react';
import { MonitorIcon, MoonIcon, SunIcon } from './icons';
import { Toggle } from './ui';
import { useTheme, type ThemePreference } from '../lib/theme';

const CHOICES: Array<{ value: ThemePreference; label: string; icon: ReactNode }> = [
  { value: 'system', label: 'System', icon: <MonitorIcon /> },
  { value: 'light', label: 'Light', icon: <SunIcon /> },
  { value: 'dark', label: 'Dark', icon: <MoonIcon /> },
];

/**
 * The three ways the app can be lit, as a row of toggles. The choice is this
 * browser's, not the account's, and it takes effect as it is pressed.
 */
export function ThemePicker() {
  const { preference, setPreference } = useTheme();
  return (
    <div role="radiogroup" aria-label="Appearance" className="flex flex-wrap gap-2">
      {CHOICES.map((choice) => (
        <Toggle
          key={choice.value}
          active={preference === choice.value}
          onChange={() => setPreference(choice.value)}
          icon={choice.icon}
          label={choice.label}
        />
      ))}
    </div>
  );
}
